// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"448":"candidateDetails","697":"candidateList"}[chunkId] + "." + {"448":"af5edb38","697":"a366417b"}[chunkId] + ".css";
};